import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import ScrollTo from "stimulus-scroll-to"
import Remote from "stimulus-remote-rails"
import ScrollReveal from "stimulus-scroll-reveal"
import PlacesAutocomplete from "stimulus-places-autocomplete"
import NestedForm from "stimulus-rails-nested-form"

const application = Application.start()
const context = require.context('@controllers', true, /\.js$/)
application.load(definitionsFromContext(context))

application.register("scroll-to", ScrollTo)
application.register("scroll-reveal", ScrollReveal)
application.register("remote", Remote)
application.register("places", PlacesAutocomplete)
application.register("nested-form", NestedForm)
